"use client";
import { Typography } from '@mui/material';
import React from 'react';

const HtmlViewer = ({ content }) => {
    return (
        <Typography dangerouslySetInnerHTML={{
            __html: content
        }} />
    );
};

export default HtmlViewer;